<template>
  <div class="statusSignalValue">
    <box ref="box"></box>
    <el-card shadow="never" :style="style">
      <el-form label-position="right" :model="searchForm" class="form" :inline="true">
        <el-form-item :label="$t('panelNumber')">
          <el-input-number size="mini" v-model="searchForm.controllerNo" :min="0" :max="254"></el-input-number>
        </el-form-item>
        <el-form-item :label="$t('loopNo')">
          <el-input-number size="mini" v-model="searchForm.loopNo" :min="0" :max="254"></el-input-number>
        </el-form-item>
        <el-form-item :label="$t('componentNumber')">
          <el-input-number size="mini" v-model="searchForm.codeNo" :min="0" :max="254"></el-input-number>
        </el-form-item>
        <el-form-item style="float: right">
          <el-button style="width: 90px" type="primary" :loading="searching" @click="_getDeviceBackgroundElec">{{$t('queryButton')}}</el-button>
        </el-form-item>
      </el-form>
      <span class="text">{{$t('backgroundCurrent')}}：{{backgroundElec}}</span><span>{{$t('stateCurrent')}}：{{statElec}}</span>
    </el-card>
  </div>
</template>

<script>
import Box from "@/components/Box";
import {getDeviceBackgroundElec} from "api/test"
import Status from "components/Status";
export default {
  name: "statusSignalValue",
  mixins: [Status],
  components: {
    Box
  },
  data() {
    return {
      searchForm: {
        controllerNo: '',
        loopNo: '',
        codeNo: ''
      },
      bottomHeight: null,
      statElec: '',
      backgroundElec: '',
      style: null,
      searching: false
    }
  },
  mounted() {
    this.calcHeight()
  },
  created(){
    this.searchForm.controllerNo = this.$store.state.controlInfo.controllerNo
  },
  computed: {
    controllInfo() {
      return this.$store.state.controlInfo
    }
  },
  methods: {
    calcHeight(){
      setTimeout(() => {
        this.bottomHeight = this.$refs.box.$el.clientHeight + 'px'
        this.style = `height: calc(100vh - 100px - ${this.bottomHeight})`
      }, 20)
    },
    handleChange(value) {
      console.log(value);
    },
    _getDeviceBackgroundElec() {
      this.searching = true
      this.show()
      let searchParams = {
        controllerNo: this.searchForm.controllerNo,
        loopNo: this.searchForm.loopNo,
        codeNo: this.searchForm.codeNo,
        controllerPsn: this.controllInfo.controllerPsn
      }
      getDeviceBackgroundElec(searchParams).then((res) => {
        if (res.code === 1) {
          this.backgroundElec = res.data.backgroundElec
          this.statElec = res.data.statElec
          this.searching = false
          this.success(res.message ? res.message : '操作成功')
        }
      }).catch(() => {
        this.failed()
        this.searching = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.statusSignalValue{
  .text{
    display: inline-block;
    margin-right: 10px;
  }
}
</style>
